export enum FeedbackStatus {
    Created = 0,
    Invited = 1,
    Submitted = 2,
    Reviewed = 3,
    Deleted = 4
}